module.exports = __webpack_public_path__ + "static/media/sur.1f1e6aad.m4a";